(() => {
  const root = window.Shopify?.routes?.root || '/';
  const section = document.querySelector('[data-pv-discovery]');
  if (!section) return;

  const configEl = section.querySelector('[data-pv-discovery-config]');
  if (!configEl) return;
  const config = JSON.parse(configEl.textContent || '{}');

  const seen = new Set([String(config.id), String(config.handle)]);
  const relatedGrid = section.querySelector('[data-pv-related-grid]');
  const sentinel = section.querySelector('[data-pv-related-sentinel]');
  const loadingEl = section.querySelector('[data-pv-related-loading]');
  const moreBtn = section.querySelector('[data-pv-related-more]');
  const statusEl = section.querySelector('[data-pv-related-status]');

  // --- 1. Récemment consultés (STRICTEMENT 2 PRODUITS MAXIMUM) ---
  let history = [];
  try {
    const raw = JSON.parse(localStorage.getItem('pv-recent-products') || '[]');
    history = raw.filter(h => h && h !== config.handle && /^[a-z0-9-]+$/.test(h));
    localStorage.setItem('pv-recent-products', JSON.stringify([config.handle, ...history].slice(0, 24)));
  } catch {}

  const money = p => new Intl.NumberFormat('fr-FR',{minimumFractionDigits:2,maximumFractionDigits:2}).format(p/100)+' DH';

  function createCard(p) {
    const c = document.createElement('div');
    c.className = 'pv-card-box pv-discovery-card';

    // Discount badge
    const priceVal = p.price || 0;
    const compareVal = p.compare || p.compare_at_price || 0;
    let discount = 0;
    if (compareVal > priceVal) {
      discount = Math.round(((compareVal - priceVal) * 100) / compareVal);
    }
    if (discount > 0) {
      const badges = document.createElement('div');
      badges.className = 'pv-card-top-badges';
      const bDisc = document.createElement('span');
      bDisc.className = 'pv-badge-discount';
      bDisc.textContent = '-' + discount + '%';
      badges.append(bDisc);
      c.append(badges);
    }

    // Image link
    const prodUrl = p.url || (root + 'products/' + p.handle);
    const aImg = document.createElement('a');
    aImg.href = prodUrl;
    aImg.className = 'pv-card-img-link';
    aImg.setAttribute('aria-label', p.title);

    const img = document.createElement('img');
    const rawImg = p.image || p.featured_image;
    if (rawImg) {
      try {
        const u = new URL(rawImg, location.origin);
        u.searchParams.set('width', '400');
        img.src = u.href;
      } catch {
        img.src = rawImg;
      }
    } else {
      img.src = '';
    }
    img.alt = p.title;
    img.className = 'pv-card-img';
    img.loading = 'lazy';
    img.width = 200;
    img.height = 200;
    aImg.append(img);
    c.append(aImg);

    // Body
    const body = document.createElement('div');
    body.className = 'pv-card-body';

    // Vendor pill
    const bWrap = document.createElement('div');
    bWrap.className = 'pv-card-brand-wrap';
    const bSpan = document.createElement('span');
    bSpan.className = 'pv-card-brand';
    bSpan.textContent = p.handle === 'heliocare-pigment-solution-fluid-spf50-50ml-gel-creme-light-offert-pack' ? 'HELIOCARE' : (p.vendor || 'PARAPHARMACIE');
    bWrap.append(bSpan);
    body.append(bWrap);

    // Title
    const aTitle = document.createElement('a');
    aTitle.href = prodUrl;
    aTitle.className = 'pv-card-title-link';
    aTitle.title = p.title;
    const h = document.createElement('h3');
    h.className = 'pv-card-title';
    h.textContent = p.title;
    aTitle.append(h);
    body.append(aTitle);

    // Price row
    const pRow = document.createElement('div');
    pRow.className = 'pv-card-price-row';
    const pSpan = document.createElement('span');
    pSpan.className = 'pv-card-price';
    pSpan.textContent = money(priceVal);
    pRow.append(pSpan);
    if (compareVal > priceVal) {
      const del = document.createElement('del');
      del.className = 'pv-card-compare';
      del.textContent = money(compareVal);
      pRow.append(del);
    }
    body.append(pRow);

    // Actions
    const actions = document.createElement('div');
    actions.className = 'pv-promo-card-actions';

    const isAvailable = p.available !== undefined ? p.available : true;
    const isSingle = p.single !== undefined ? p.single : (p.variants ? p.variants.length === 1 : true);
    const variantId = p.variant || (p.variants && p.variants.length ? p.variants[0].id : null);

    if (isAvailable && isSingle && variantId) {
      const f = document.createElement('form');
      f.action = root + 'cart/add';
      f.method = 'post';
      f.dataset.pvCardCart = '';
      const inId = document.createElement('input');
      inId.type = 'hidden';
      inId.name = 'id';
      inId.value = variantId;
      const inQty = document.createElement('input');
      inQty.type = 'hidden';
      inQty.name = 'quantity';
      inQty.value = '1';
      f.append(inId, inQty);

      const btn = document.createElement('button');
      btn.type = 'submit';
      btn.className = 'pv-card-btn-ajouter';
      btn.setAttribute('aria-label', 'Ajouter ' + p.title + ' au panier');
      btn.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M3 3h2l2.4 12h11.2l2-8H6"/><circle cx="9" cy="20" r="1"/><circle cx="18" cy="20" r="1"/></svg><span data-pv-cart-label>Ajouter</span>';
      const err = document.createElement('p');
      err.setAttribute('role', 'alert');
      err.hidden = true;
      f.append(btn, err);
      actions.append(f);
    } else if (isAvailable) {
      const aChoose = document.createElement('a');
      aChoose.href = prodUrl;
      aChoose.className = 'pv-card-btn-ajouter';
      aChoose.textContent = 'Choisir';
      actions.append(aChoose);
    } else {
      const btnOut = document.createElement('button');
      btnOut.className = 'pv-card-btn-ajouter';
      btnOut.disabled = true;
      btnOut.textContent = 'Épuisé';
      actions.append(btnOut);
    }

    // WhatsApp Direct Contact Button
    const wa = document.createElement('a');
    wa.className = 'pv-promo-wa';
    const waMsg = 'Bonjour ParaVogue, je souhaite des informations sur ' + p.title + ' : ' + new URL(prodUrl, location.origin).href;
    wa.href = 'https://wa.me/212774022079?text=' + encodeURIComponent(waMsg);
    wa.target = '_blank';
    wa.rel = 'noopener';
    wa.setAttribute('aria-label', 'Question sur ' + p.title + ' sur WhatsApp');
    wa.innerHTML = '<svg width="23" height="23" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" aria-hidden="true"><path d="M20.5 11.7a8.5 8.5 0 0 1-12.6 7.5L3 20.5l1.3-4.8A8.5 8.5 0 1 1 20.5 11.7Z"/><path d="M8.5 7.5c-.7.2-1 1-.9 1.7.3 2.5 2.5 4.8 5.2 5.7.8.3 1.8-.2 2-1l-2-1-.7.7a7.1 7.1 0 0 1-2.9-2.9l.7-.7-1-2.5Z"/></svg>';
    actions.append(wa);

    body.append(actions);
    c.append(body);
    return c;
  }

  // Render Recent Products (Strictly 2 products)
  async function initRecent() {
    // Only slice first 2 products from history
    const targetHandles = history.slice(0, 2);
    if (!targetHandles.length) return;

    const fetches = await Promise.allSettled(
      targetHandles.map(h =>
        fetch(root + 'products/' + h + '.js')
          .then(r => (r.ok ? r.json() : Promise.reject()))
      )
    );

    const validProducts = fetches
      .filter(f => f.status === 'fulfilled' && f.value && f.value.available)
      .map(f => f.value);

    if (validProducts.length) {
      const recentSection = section.querySelector('[data-pv-discovery-group="recent"]');
      const recentGrid = section.querySelector('[data-pv-recent-grid]');
      if (recentSection && recentGrid) {
        recentGrid.replaceChildren(...validProducts.map(createCard));
        recentSection.hidden = false;
      }
    }
  }

  let page = 1, busy = false, exhausted = false, failed = false, observer;
  const errorEl=section.querySelector('[data-pv-related-error]');
  const retryButton=section.querySelector('[data-pv-related-retry]');
  async function loadFeedBatch() {
    if(busy || exhausted || failed) return;
    busy=true;if(loadingEl)loadingEl.hidden=false;if(errorEl)errorEl.hidden=true;
    const controller=new AbortController();
    const timeout=setTimeout(()=>controller.abort(),15000);
    try {
      const res=await fetch(root+'collections/promotion?section_id=pv-related-feed&page='+page,{signal:controller.signal});
      if(!res.ok)throw Error('Promotions indisponibles');
      const doc=new DOMParser().parseFromString(await res.text(),'text/html');
      const node=doc.querySelector('[data-pv-related-feed]');if(!node)throw Error('Flux absent');
      const data=JSON.parse(node.textContent||'{}');
      for(const p of data.products||[]) {const id=String(p.id),h=String(p.handle);if(seen.has(id)||seen.has(h))continue;seen.add(id);seen.add(h);relatedGrid.append(createCard(p))}
      page=data.next?Number(new URL(data.next,location.origin).searchParams.get('page')||page+1):page+1;
      exhausted=!data.next;
      section.dataset.feedLoaded=relatedGrid.children.length;section.dataset.feedExhausted=String(exhausted);
      section.dataset.feedFailed='false';
      if(exhausted){if(sentinel)sentinel.hidden=true;observer?.disconnect()}
    }catch(e){failed=true;section.dataset.feedFailed='true';if(errorEl)errorEl.hidden=false}
    finally{
      clearTimeout(timeout);busy=false;if(loadingEl)loadingEl.hidden=true;
      if(!failed&&!exhausted&&sentinel&&sentinel.getBoundingClientRect().top<innerHeight+800)requestAnimationFrame(loadFeedBatch);
    }
  }
  retryButton?.addEventListener('click',()=>{failed=false;loadFeedBatch()});
  // Direct buy handler (for any direct checkout action)
  document.addEventListener('click', async e => {
    const b = e.target.closest('[data-pv-direct-buy]');
    if (!b || b.disabled || b.dataset.busy) return;
    const f = b.closest('form');
    if (!f || !f.reportValidity() || f.querySelector('button[name="add"]')?.disabled) return;
    b.dataset.busy = '1';
    b.disabled = true;
    b.textContent = 'Préparation…';
    try {
      const r = await fetch(root + 'cart/add.js', {
        method: 'POST',
        body: new FormData(f),
        headers: { Accept: 'application/json' }
      });
      const x = await r.json();
      if (!r.ok) throw Error(x.description || 'Impossible d’ajouter le produit.');
      location.assign(root + 'checkout');
    } catch (error) {
      alert(error.message);
      delete b.dataset.busy;
      b.disabled = false;
      b.textContent = 'Achat direct';
    }
  });

  // Init recent immediately
  initRecent();

  // Initial feed batch
  loadFeedBatch();

  if(sentinel && 'IntersectionObserver' in window){observer=new IntersectionObserver(entries=>{if(entries.some(e=>e.isIntersecting))loadFeedBatch()},{root:null,rootMargin:'800px'});observer.observe(sentinel)}
})();